import type { RyftPaymentSessionOrderGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementPaymentSessionOrder = (
  paymentSessionId: string | null,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.RyftManagementPaymentSessionOrder,
      paymentSessionId,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `ryft-management/payment-sessions/${paymentSessionId}/order`,
      }).then(
        (response) =>
          apiV2AssertResponse<RyftPaymentSessionOrderGetResponseType>(response)
            .data,
      ),
    ...getDefaultQueryOptionsV2<RyftPaymentSessionOrderGetResponseType>({
      context: { scope: "business", user, business },
      options: { enabled: !!paymentSessionId, retry: false },
    }),
  });
};
